var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "calendarNoteCreate" }, [
    _c("h1", { staticClass: "calendarNoteCreate__title hidden-mobile-down" }, [
      _c("span", [
        _vm._v(
          _vm._s(_vm.nowMode === "AstroCalendarNoteEdit" ? "編輯" : "建立")
        )
      ]),
      _vm._v("\n    共时历笔记\n  ")
    ]),
    _vm.currentInterpretation
      ? _c(
          "div",
          { staticClass: "calendarNoteCreate__box" },
          [
            _c("div", { staticClass: "calendarNoteCreate__box__detail" }, [
              _c(
                "div",
                { staticClass: "calendarNoteCreate__box__detail__picArea" },
                [_c("img", { attrs: { src: _vm.topicImg, alt: "" } })]
              ),
              _c(
                "div",
                { staticClass: "calendarNoteCreate__box__detail__date" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.moment(_vm.editDate).format("MM/DD")) +
                      "\n        "
                  ),
                  _c("span", [
                    _vm._v(_vm._s(_vm.moment(_vm.editDate).format("ddd")))
                  ])
                ]
              ),
              _c(
                "div",
                { staticClass: "calendarNoteCreate__box__detail__highlight" },
                [
                  _vm._v(
                    "\n        ★ " +
                      _vm._s(_vm.currentInterpretation.Highlight) +
                      "\n      "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "calendarNoteCreate__box__switchDate" }, [
              _c("div", [_vm._v("写下你在这天的观察吧：）")]),
              _c(
                "div",
                {
                  staticClass: "calendarNoteCreate__box__switchDate__btn",
                  on: {
                    click: function($event) {
                      _vm.dateModal = true
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets//共時曆/swichDateIcon.svg"),
                      alt: ""
                    }
                  }),
                  _c("span", [_vm._v("切换时间")])
                ]
              )
            ]),
            _c(
              "v-dialog",
              {
                ref: "dialog",
                attrs: { width: "290px", persistent: "" },
                model: {
                  value: _vm.dateModal,
                  callback: function($$v) {
                    _vm.dateModal = $$v
                  },
                  expression: "dateModal"
                }
              },
              [
                _c(
                  "v-date-picker",
                  {
                    staticClass: "picker date-picker",
                    attrs: {
                      "first-day-of-week": 0,
                      locale: "zh-cn",
                      scrollable: "",
                      "header-color": "rgba(217, 217, 217, 0.25)",
                      color: "primary",
                      max: "2200-12-31",
                      min: "1910-01-01"
                    },
                    model: {
                      value: _vm.temp_date,
                      callback: function($$v) {
                        _vm.temp_date = $$v
                      },
                      expression: "temp_date"
                    }
                  },
                  [
                    _c("v-spacer"),
                    _c(
                      "v-btn",
                      {
                        attrs: { text: "", color: "error" },
                        on: {
                          click: function($event) {
                            _vm.dateModal = false
                          }
                        }
                      },
                      [_vm._v("取消")]
                    ),
                    _c(
                      "v-btn",
                      {
                        attrs: { text: "", color: "error" },
                        on: {
                          click: function($event) {
                            return _vm.saveDateTime()
                          }
                        }
                      },
                      [_vm._v("确认")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm.showAlreadyWriteNotice
              ? _c("div", { staticClass: "calendarNoteCreate__box__notice" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/月亮日記/紅底驚嘆號.svg"),
                      alt: ""
                    }
                  }),
                  _c("div", [
                    _vm._v("\n        你已经写过\n        "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.astroCalendarNoteEdit.Title) +
                          " (" +
                          _vm._s(_vm.editDate) +
                          ")"
                      )
                    ]),
                    _vm._v(
                      "\n        的笔记，已经无法再新增。请选择其它日期来建立笔记喔！\n      "
                    )
                  ])
                ])
              : _vm._e(),
            _c("div", { staticClass: "calendarNoteCreate__box__line" }),
            _c("div", { staticClass: "calendarNoteCreate__box__input" }, [
              _c(
                "div",
                { staticClass: "calendarNoteCreate__box__input__title" },
                [_vm._v("你的心情如何呢")]
              ),
              _c(
                "div",
                {
                  staticClass: "calendarNoteCreate__box__input__selectEmotion"
                },
                _vm._l(_vm.emotionList, function(item) {
                  return _c(
                    "div",
                    {
                      key: item.id,
                      staticClass:
                        "calendarNoteCreate__box__input__selectEmotion__item"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "calendarNoteCreate__box__input__selectEmotion__item__pic",
                          class: { active: _vm.splitMoods.includes(item.id) },
                          style:
                            "background-color:" +
                            (_vm.splitMoods.includes(item.id)
                              ? item.color
                              : "") +
                            " ",
                          on: {
                            click: function($event) {
                              return _vm.moodsHandler(item.id)
                            }
                          }
                        },
                        [
                          _vm.splitMoods.includes(item.id)
                            ? _c("img", { attrs: { src: item.active_icon } })
                            : _c("img", { attrs: { src: item.normal_icon } })
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "calendarNoteCreate__box__input__selectEmotion__item__label"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.label) +
                              "\n          "
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              ),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.MoodContent,
                    expression: "MoodContent"
                  }
                ],
                staticClass: "detail area1",
                attrs: {
                  cols: "30",
                  placeholder: "來寫下今天的心情吧 :)",
                  maxlength: "50"
                },
                domProps: { value: _vm.MoodContent },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.MoodContent = $event.target.value
                  }
                }
              }),
              _c("span", [
                _vm._v(
                  "上限为 50 个字 (" + _vm._s(_vm.MoodContent.length) + "/50)"
                )
              ])
            ]),
            _c("div", { staticClass: "calendarNoteCreate__box__input" }, [
              _c(
                "div",
                { staticClass: "calendarNoteCreate__box__input__title" },
                [_vm._v("写下今日笔记")]
              ),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.Content,
                    expression: "Content"
                  }
                ],
                staticClass: "detail area2",
                attrs: {
                  cols: "30",
                  placeholder: "來寫寫今日的筆記吧 :)",
                  maxlength: "500"
                },
                domProps: { value: _vm.Content },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.Content = $event.target.value
                  }
                }
              }),
              _c("span", [
                _vm._v(
                  "上限为 500 个字 (" + _vm._s(_vm.Content.length) + "/500)"
                )
              ])
            ]),
            _c("div", { staticClass: "calendarNoteCreate__box__btn" }, [
              _c(
                "div",
                {
                  staticClass: "calendarNoteCreate__box__btn__cancel",
                  on: { click: _vm.cancel }
                },
                [_vm._v("\n        取消\n      ")]
              ),
              _c(
                "div",
                {
                  staticClass: "calendarNoteCreate__box__btn__ok",
                  class: {
                    disable: _vm.showAlreadyWriteNotice
                  },
                  on: { click: _vm.save }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.nowMode === "AstroCalendarNoteEdit"
                          ? "儲存"
                          : "建立"
                      ) +
                      "\n      "
                  )
                ]
              )
            ])
          ],
          1
        )
      : _c("div", [_vm._v("loading")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }